import {
    GO_BACK,
    GO_TO_SCREEN,
    GO_TO_SCREEN_AND_RESET_HISTORY,
    SET_HISTORY_SCREEN_STATE,
} from '../constants/actions';
import {
    routesInterceptedOnBack,
    routesTriggerAlertOnBack,
} from '../helpers/router';

export const goToScreen = route => {
    return {
        type: GO_TO_SCREEN,
        route,
    };
};

export const goToScreenAndReset = route => {
    return {
        type: GO_TO_SCREEN_AND_RESET_HISTORY,
        route,
    };
};

export const setHistoryScreenState = (screen, state) => {
    return {
        type: SET_HISTORY_SCREEN_STATE,
        screen,
        state,
    };
};

export const goBackAScreen = () => {
    return {
        type: GO_BACK,
    };
};

export const goBack = () => {
    return (dispatch, getState) => {
        const { currentRoute } = getState().router;
        if (routesTriggerAlertOnBack[currentRoute]) {
            alert('Confirmation Message');
        } else if (routesInterceptedOnBack[currentRoute] !== undefined) {
            dispatch(goToScreen(routesInterceptedOnBack[currentRoute]));
        } else {
            dispatch(goBackAScreen());
        }
    };
};
